import React from 'react';
import PropTypes from 'prop-types';
import { NoFilteredClaims } from '../noResults/noFilteredClaims';
import { ClaimDetailPropTypes, SavedClaimPropTypes } from '../../../propTypes/claimDetails';
import { FullPetDetailsPropTypes } from '../../../propTypes/petDetails';
import { ClaimDetailItem } from '../claimDetails/claimDetailItem';
import { FilterClaimsByPolicyNo } from '../../../helpers/claimHelpers';

export const ClaimsPanel = ({
  icon = 'paw',
  claims,
  headingText,
  filter,
  petDetails,
  includeCompleteButton = false,
  includeDeleteButton = false,
  onShowMore,
  showMoreAvailable = false,
  isLoading = false
}) => {
  const filteredClaims = filter ? FilterClaimsByPolicyNo({ claims, policyNumber: filter }) : claims;

  return (
    <section className="claimDetails filteredClaims savedClaims">
      <h2>{headingText}</h2>
      {filteredClaims.length ? (
        <ul className="filteredClaimsList">
          {filteredClaims.map((claim) => (
            <ClaimDetailItem
              icon={icon}
              key={claim.ClaimNumber || claim.CustomerClaimId}
              petDetails={petDetails}
              claim={claim}
              includeCompleteButton={includeCompleteButton}
              includeDeleteButton={includeDeleteButton}
            />
          ))}

          {showMoreAvailable && (
            <div className="showMoreWrapper">
              <button
                type="button"
                className="button secondary"
                onClick={onShowMore}
                disabled={isLoading}
              >
                {isLoading ? 'Loading…' : 'Show more'}
              </button>
            </div>
          )}
        </ul>
      ) : (
        <NoFilteredClaims filterType="saved" />
      )}
    </section>
  );
};

ClaimsPanel.propTypes = {
  icon: PropTypes.string,
  claims: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(SavedClaimPropTypes), PropTypes.shape(ClaimDetailPropTypes)])
  ),
  headingText: PropTypes.string,
  filter: PropTypes.string,
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  includeCompleteButton: PropTypes.bool,
  includeDeleteButton: PropTypes.bool,
  onShowMore: PropTypes.func,
  showMoreAvailable: PropTypes.bool,
  isLoading: PropTypes.bool
};
